(function () {
  const root = document.querySelector('[data-ws-track]');
  if (!root) return;

  const orderTab = root.querySelector('[data-track-tab="order"]');
  const trackingTab = root.querySelector('[data-track-tab="tracking"]');
  const orderPanel = root.querySelector('[data-track-panel="order"]');
  const trackingPanel = root.querySelector('[data-track-panel="tracking"]');
  const findButton = root.querySelector('[data-find-order]');
  const trackButton = root.querySelector('[data-track-number]');
  const orderInput = root.querySelector('#ws-track-order');
  const trackingInput = root.querySelector('#ws-track-number');
  const trackingResult = root.querySelector('[data-tracking-result]');
  const yqContainer = root.querySelector('#YQContainer');
  const embedWrap = root.querySelector('[data-order-embed]');
  const embedContainer = root.querySelector('#ws-embedded-YQContainer');
  const orderResult = root.querySelector('[data-order-result]');
  const supportEmail = root.getAttribute('data-support-email') || 'info@wroughtsiron.com';
  const loggedIn = root.getAttribute('data-logged-in') === 'true';

  let customerOrders = [];
  const ordersNode = document.getElementById('ws-customer-orders');
  if (ordersNode) {
    try {
      customerOrders = JSON.parse(ordersNode.textContent);
    } catch (error) {
      customerOrders = [];
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeOrderName(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/WROUGHTSIRON/g, '')
      .replace(/#/g, '')
      .trim();
  }

  function renderOrder(order) {
    const items = (order.line_items || [])
      .map(function (item) {
        const image = item.image
          ? '<div class="ws-track__item-image"><img src="' +
            escapeHtml(item.image) +
            '" alt="' +
            escapeHtml(item.title) +
            '"></div>'
          : '';
        const variant = item.variant ? '<p class="ws-track__item-variant">' + escapeHtml(item.variant) + '</p>' : '';
        const statusClass = item.fulfilled ? 'ws-track__status--shipped' : 'ws-track__status--processing';
        const statusLabel = item.fulfilled ? 'Shipped' : 'Processing';
        return (
          '<div class="ws-track__item">' +
          image +
          '<div>' +
          '<p class="ws-track__item-name">' +
          escapeHtml(item.title) +
          '</p>' +
          variant +
          '<p class="ws-track__item-qty">Qty: ' +
          escapeHtml(item.quantity) +
          ' · ' +
          escapeHtml(item.price) +
          '</p>' +
          '<span class="ws-track__status ' +
          statusClass +
          '">' +
          statusLabel +
          '</span>' +
          '</div></div>'
        );
      })
      .join('');

    const address = order.shipping_address
      ? '<div class="ws-track__address"><h3>Delivery</h3><div>' + escapeHtml(order.shipping_address) + '</div></div>'
      : '';
    const statusLink = order.status_url
      ? '<p><a class="ws-track__status-link" href="' +
        escapeHtml(order.status_url) +
        '" target="_blank" rel="noopener">View full order status</a></p>'
      : '';

    return (
      '<div class="ws-track__order"><h3 class="ws-track__order-title">Order ' +
      escapeHtml(order.name) +
      '</h3>' +
      '<p class="ws-track__order-meta">' +
      escapeHtml(order.financial_status || '') +
      ' · ' +
      escapeHtml(order.fulfillment_status || '') +
      ' · ' +
      escapeHtml(order.total_price || '') +
      '</p>' +
      items +
      address +
      statusLink +
      '</div>'
    );
  }

  function switchTab(name) {
    const isOrder = name === 'order';
    orderTab.classList.toggle('is-active', isOrder);
    trackingTab.classList.toggle('is-active', !isOrder);
    orderTab.setAttribute('aria-selected', isOrder ? 'true' : 'false');
    trackingTab.setAttribute('aria-selected', isOrder ? 'false' : 'true');
    orderPanel.hidden = !isOrder;
    trackingPanel.hidden = isOrder;
  }

  function setMessage(target, text, isError) {
    target.innerHTML = text
      ? '<p class="ws-track__message' + (isError ? ' ws-track__message--error' : '') + '">' + text + '</p>'
      : '';
  }

  function waitForYQ(callback) {
    if (typeof YQV5 !== 'undefined') {
      callback();
      return;
    }
    let attempts = 0;
    const timer = setInterval(function () {
      attempts += 1;
      if (typeof YQV5 !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
        callback(new Error('tracking-unavailable'));
      }
    }, 250);
  }

  function trackNumber(number, containerId, fallbackEl) {
    const num = String(number || '').trim();
    if (!num) {
      setMessage(fallbackEl, 'Please enter a tracking number.', true);
      return;
    }

    fallbackEl.innerHTML = '<p class="ws-track__message">Loading tracking details…</p>';
    waitForYQ(function (error) {
      if (error || typeof YQV5 === 'undefined') {
        const url = 'https://www.17track.net/en/track?nums=' + encodeURIComponent(num);
        fallbackEl.innerHTML =
          '<p class="ws-track__message">Open carrier tracking: <a class="ws-track__status-link" href="' +
          url +
          '" target="_blank" rel="noopener">Track on 17TRACK</a></p>';
        return;
      }
      fallbackEl.innerHTML = '';
      YQV5.trackSingle({
        YQ_ContainerId: containerId,
        YQ_Height: 560,
        YQ_Fc: '0',
        YQ_Lang: 'en',
        YQ_Num: num,
      });
    });
  }

  function findOrder() {
    if (!loggedIn) return;

    const wanted = normalizeOrderName(orderInput && orderInput.value);
    if (!wanted) {
      setMessage(orderResult, 'Please enter your order number.', true);
      return;
    }

    const match = customerOrders.find(function (order) {
      return normalizeOrderName(order.name) === wanted;
    });

    if (!match) {
      setMessage(
        orderResult,
        'No matching order was found in this account. Check the order number, or email ' +
          supportEmail +
          '.',
        true
      );
      embedWrap.hidden = true;
      return;
    }

    orderResult.innerHTML = renderOrder(match);
    if (match.tracking_number) {
      embedWrap.hidden = false;
      trackNumber(match.tracking_number, 'ws-embedded-YQContainer', embedContainer);
    } else {
      embedWrap.hidden = true;
    }
  }

  orderTab.addEventListener('click', function () {
    switchTab('order');
  });
  trackingTab.addEventListener('click', function () {
    switchTab('tracking');
  });

  if (findButton) {
    findButton.addEventListener('click', findOrder);
  }
  if (orderInput) {
    orderInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        findOrder();
      }
    });
  }

  trackButton.addEventListener('click', function () {
    trackNumber(trackingInput.value, 'YQContainer', yqContainer);
    trackingResult.innerHTML = '';
  });

  if (trackingInput) {
    trackingInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        trackButton.click();
      }
    });
  }

  const params = new URLSearchParams(window.location.search);
  const nums = params.get('nums') || params.get('tracking');
  if (nums) {
    trackingInput.value = nums;
    switchTab('tracking');
    trackNumber(nums, 'YQContainer', yqContainer);
  }
})();
